import React from "react";

import { ReactComponent as PosBossCloud } from "assets/images/posBossCloud.svg";
import { useTranslation } from "react-i18next";

import Icon from "Atoms/Icons";
import { WithLoadingComponent } from "Atoms/Loading";

import { VenueErrorPage } from "./ErrorPage";

export const LoadingPage = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-venue-secondary overflow-y-hidden h-screen">
      <div className="flex flex-col overflow-y-auto mx-auto max-w-screen-sm w-full bg-venue-secondary h-screen items-center justify-center space-y-32">
        <div className="h-48 text-venue-brand animate-pulse my-16">
          <PosBossCloud />
        </div>
        <h3 className="text-xl">{t("common.loading")}</h3>
      </div>
    </div>
  );
};

export const LoadingSpinner = ({ ...props }) => {
  return (
    <Icon
      color={undefined}
      size={undefined}
      icon="loading"
      className="animate-spin align-middle inline-block"
      {...props}
    />
  );
};

const Loading = WithLoadingComponent(
  () => (
    <div>
      <LoadingPage />
    </div>
  ),
  () => (
    <div>
      <VenueErrorPage resetError={() => {}} errorMessage="Error" />
    </div>
  )
);
export const isLoading = (status: ("error" | "pending" | "success")[]) => {
  return status.some((s) => s === "pending");
};

export { useLoadingState } from "Atoms/Loading";
export default Loading;
